import {defineCssVars} from '@chakra-ui/styled-system';

export const defineGraphCSSVars = (part: string, vars: Array<string>) => {
  return defineCssVars(`graph_${part}`, vars);
};

export const defineGraphNodeCSSVars = (part: string, vars: Array<string>) => {
  return defineGraphCSSVars(`graph_node${part ? `_${part}` : ``}${part}`, vars);
};
